import { makeStyles } from "@material-ui/core";
import { h6Medium } from "../../../shared/typography";

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: "relative",
    display: "flex",
    alignIten: "center",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    ...h6Medium,
    width: 175,
  },
  icon: {
    width: 18,
    height: 18,
  },
  dropdown: {
    position: "absolute",
    top: "100%",
    left: 0,
    minWidth: "100%",
    background: "#fff",
    border: "none",
    marginTop: 6,
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  },
  item: {
    padding: "10px 14px",
    ...h6Medium,
    cursor: "pointer",
    "&:hover": {
      background: "#f5f5f5",
    },
  },
  itemDisabled: {
    color: "#9e9e9e",
    cursor: "default",
    background: "#fafafa",
    "&:hover": {
      background: "#fafafa",
    },
  },
}));
